<style lang="scss" scoped>
.modal {
  z-index: 10002;
  & .modal-dialog {
    max-width: 380px;
  }
}
.modal-backdrop {
  z-index: 10001;
}
</style>
<script>
import SRCLearnMoreComponent from '@/components/shared/src-learn-more/src-learn-more.vue'

export default {
  name: 'Click2PayModalComponent',
  components: {
    'src-learn-more': SRCLearnMoreComponent
  },
  props: {
    show: Boolean,
    cardbrand: Array,
    displayokbutton: Boolean
  },

  computed: {
    showModal: function () {
      return this.show
    }
  },

  methods: {
    close () {
      this.$emit('onClose')
    }
  }
}
</script>

<template>
  <div v-if="showModal">
    <div
      id="click2pay-modal"
      :class="{ fade: showModal }"
      class="modal show"
      tabindex="-1"
      role="dialog"
      aria-labelledby="click2pay-modal"
      aria-hidden="true"
      style="display: block"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <src-learn-more
              :cardbrand="cardbrand"
              :displayokbutton="displayokbutton"
              @close="close"/>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show" />
  </div>
</template>
